// Import API request handler
import { request } from "../api/api";

// Handle user login with email and password
export const login = (data) => {
  return request.post('/login', data);
};

// Register new user account
export const register = (data) => {
  return request.post('/register', data);
}

// Log out current user
export const logout = () => {
  return request.post('/logout');
}

// Change password for logged-in user
export const changePassword = (data) => {
  return request.post('/change-password', data)
}

// Send forgot password email
export const forgotPassword = (data) => {
  return request.post("/forgot-password", data)
}

// Reset password with token from email
export const resetPassword = (data) => {
  return request.post("/reset-password", data)
}